export default __webpack_public_path__ + "static/media/JACKET_EM_2_GLB.1a69ef7e.glb";